import React, {useState} from 'react';
import {Container, Collapse, Navbar, NavbarToggler, Nav, NavItem, NavLink, Button} from 'reactstrap';
import classNames from 'classnames';
import './Header.scss';

export default function Header({
  bgColor = 'purple',
  textColor = 'white',
  lockupWhite = false,
  className = undefined,
  logoUrlOverride = undefined,
  logoAltOverride = undefined,
  logoWidthOverride = undefined,
  logoHeightOverride = undefined,
  logoCentered = false,
  adLockup = false,
  ...props
}) {
  const [collapsed, setCollapsed] = useState(true);
  const toggleNavbar = () => setCollapsed(!collapsed);
  return (
    <header
      className={classNames(`header`, `background-${bgColor}`, `text-${textColor}`, `d-flex`, `flex-column`, className)}
    >
      <Container className={classNames(`headerContainer`, `my-auto`)}>
        <Navbar className={classNames(`headerNavbar`, `p-0`)} expand="lg" container={false}>
          <div className={classNames(`headerNavbarBrand`, `flex-grow-1`)}>
            {logoUrlOverride ? (
              <img
                className={classNames(`headerLogo`)}
                src={logoUrlOverride}
                alt={logoAltOverride}
                width={logoWidthOverride}
                height={logoHeightOverride}
              />
            ) : (
              <div className={classNames(`d-flex`, `align-items-center`, logoCentered && `justify-content-center`)}>
                <Button
                  color="headerLogo"
                  href="https://join.foodrevolution.org/offerings/"
                  target="_blank"
                  disabled={adLockup ? false : true}
                >
                  <img
                    className={classNames(`headerLogoFRN`)}
                    src={
                      lockupWhite
                        ? 'https://cdn.foodrevolution.org/global/frn-logo-2024-trademarked-white.svg'
                        : 'https://cdn.foodrevolution.org/global/frn-logo-2024-trademarked-color.svg'
                    }
                    alt="Food Revolution Network logo"
                    width={300}
                    height={116}
                  />
                </Button>
                <div className="headerLogoDivider" />
                <img
                  className={classNames(`headerLogoPROD`)}
                  src={
                    lockupWhite
                      ? 'https://cdn.foodrevolution.org/tt2/tt2m-logo-202401-white.svg'
                      : 'https://cdn.foodrevolution.org/tt2/tt2m-logo-2024.svg'
                  }
                  alt="tackling type 2 masterclass text logo"
                  width={300}
                  height={66}
                />
              </div>
            )}
          </div>
        </Navbar>
      </Container>
    </header>
  );
}
